/*eslint-disable*/
import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Moment from 'react-moment';
import ReactQuill from 'react-quill';

import {
    Input,
    Card,
    CardImg,
    CardTitle,
} from "reactstrap";

import { allChangelogTags } from '../../../common/Utils';
import PageBack from '../../../common/PageBack';
import ChangelogDetailsPane from './ChangelogDetailsPane';

import './changelog.public.scss';


const ChangelogsDetails = ({
    changelogItem,
    SmileyReactions,
}) => {
    const navigate = useNavigate();

    const goBackChangelogs = () => {
        navigate('/changelog');
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="changelog-details">
            <PageBack backHandler={goBackChangelogs} backText="Back to Changelog" />

            <div className="changelog-details-wrapper details">

                <div className="__changelog-list">
                    <Card className="changelog-details_card">
                        {/* --- changelog title --- */}
                        <CardTitle tag="h2">
                            {changelogItem.title}
                        </CardTitle>

                        {/* --- changelog cover img --- */}
                        {
                            changelogItem.settings.cover_image && (
                                <CardImg
                                    alt="Card image cap"
                                    src={changelogItem.cover_img_url}
                                    style={{
                                        height: 470,
                                        objectFit: 'cover'
                                    }}
                                    top
                                    width="100%"
                                />
                            )
                        }

                        {/* --- changelog content --- */}
                        <p style={{ margin: '25px 0' }}>
                            <ReactQuill
                                theme="bubble"
                                className="public-changelog-content details"
                                placeholder="Changelog description"
                                value={changelogItem.content}
                                readOnly={true}
                                modules={{ "toolbar": null }}
                                bounds={`#__quill-tool`}
                            />
                        </p>

                        <Input name="text"
                            type="textarea"
                            placeholder="Leave a feedback"
                            style={{ marginTop: '25px' }}
                        />
                    </Card>
                </div>
                <ChangelogDetailsPane changelogItem={changelogItem} allChangelogTags={allChangelogTags} SmileyReactions={SmileyReactions} />
            </div>
        </div >
    );
};

export default ChangelogsDetails;
